import Link from "next/link";
import React, { useContext, useState, useTransition } from "react";
import { useEffect } from "react";
import { Button } from "react-bootstrap";
import helper from "../../lib/helper";
import userModel from "../../models/user.model";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
import moment from "moment/moment";
const Page = function () {
    const [showLoader, setShowLoader] = useState(false);

    const router = useRouter();
    const queryParams = router.query;
    const { data: userData, mutate: userPageData, isLoading } = useSWR(
        queryParams || null,
        () => userModel.list(queryParams),
        config.swrConfig
    );

    const columns = [

       
        {
            Header: 'Name',
            accessor: 'name',
            className: 'col'
        },
        {
            Header: 'Email',
            accessor: 'email',
            className: 'col'
        },
        {
            Header: 'Mobile',
            accessor: 'mobile',
            className: 'col'
        },
        {
            Header: "Date",
            id: "created_at",
            Cell: ({ row }) => (
                <>
                    <div>
                    {helper.date.format(row.original.created_at)}
                    </div>
                </>
            )
            },
        {
            className: "col-auto text-end",
            Header: "Actions",
            id: "action",
            Cell: ({ row }) => (
                <>
                    <div className="btn-group btn-group-sm">
                        <Link
                            className="btn btn-primary"
                            href={`/users/${row.original.id}`}
                        >
                            <i className="bi bi-eye"></i>
                        </Link>
                        <Link
                            className="btn btn-warning"
                            href={`/users/${row.original.id}/edit`}
                        >
                            <i className="bi bi-pencil-square"></i>
                        </Link>
                        <button
                            className="btn btn-danger"
                            onClick={() => confirmDelete(row.original.id, row.original.name)}
                        >
                            <i className="bi bi-trash"></i>
                        </button>
                        <Link
                            className="btn btn-info"
                            href={`/users/${row.original.id}/childrens`}
                        >
                            <i className="bi bi-people"></i>
                        </Link>
                    
                    
                    </div>
                </>
            ),
        },



    ];
    const confirmDelete = async (id, title) => {
        await helper.sweetalert
            .confirm(`confirm to delete ${title}`, "warning")
            .then(async (result) => {
                if(result.isConfirmed){
                setShowLoader(true);
                await userModel.destroy(id).then((res) => {
                   userPageData();
                    helper.sweetalert.toast(`${title} deleted Successfully`);
                });
                setShowLoader(false);
    }});
    };

    return (
        <>
            <Heading title="Users" showLoader={isLoading || showLoader}>
                <Button className="btn btn-primary btn-sm" href="/users/create">
                    Create
                </Button>
            </Heading>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">Users List</div>
                    <div className="table-responsive">
                        <Table columns={columns} data={userData?.data || []} />
                    </div>
                    <div className="card-footer">
                        <Pagination meta={userData?.meta} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;




